import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "@/components/SignIn.vue";
import HelloWorld from "@/components/HelloWorld.vue";
import Paid from "@/components/Paid.vue";
import Course from "@/components/Cource.vue";

import store from "@/store/index.js";

import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin } from "aws-amplify-vue";

Vue.use(VueRouter);
Vue.use(AmplifyPlugin, AmplifyModules);

let user;

// getUser().then(user => {
//   if (user) {
//     router.push({ path: "/" });
//   }
// });

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
    .then(data => {
      if (data && data.signInUserSession) {
        store.commit("setUser", data);
        return data;
      }
    })
    .catch(() => {
      store.commit("setUser", null);
      return null;
    });
}

AmplifyEventBus.$on("authState", async (state) => {
  if (state === "signedOut") {
    user = null;
    store.commit("setUser", null);
    router.push({ path: "/" }, () => {});
  } else if (state === "signedIn") {
    user = await getUser();
    // router.push({ path: "/" });
    router.back();
  }
});

const routes = [
  {
    path: "/",
    name: "helloworld",
    component: HelloWorld,
  },
  {
    path: "/signin",
    name: "signin",
    component: SignIn,
  },
  {
    path: "/paid",
    name: "paid",
    component: Paid,
    meta: { requireAuth: true },
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/cource/:client/:id",
    name: "course",
    component: Course,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requireAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: "/signin",
      });
    }
    return next();
  }
  return next();
});

export default router;
